import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { convertImageUrl } from '../utils/convertImageUrl';

function FloatingPromo() {
  const [promo, setPromo] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'schedule', 'promo'), (docSnap) => {
      if (docSnap.exists()) {
        setPromo(docSnap.data());
      } else {
        setPromo(null);
      }
    }, (err) => {
      console.error('Error listening to promo:', err);
    });
    return () => unsubscribe();
  }, []);

  if (!promo || !promo.enabled || dismissed) return null;

  // Check if the floating card is enabled
  if (!promo.showFloating) return null;

  return (
    <>
      {/* Expanded overlay */}
      {expanded && (
        <div className="floating-promo-overlay" onClick={() => setExpanded(false)}>
          <div className="floating-promo-expanded floating-promo-auto" onClick={(e) => e.stopPropagation()}>
            <button
              className="floating-promo-expanded-close"
              onClick={() => setExpanded(false)}
              aria-label="Close promo"
            >
              &times;
            </button>
            {promo.imageUrl && (
              <img
                src={convertImageUrl(promo.imageUrl)}
                alt={promo.title}
                className="floating-promo-expanded-img"
              />
            )}
            {promo.description && (
              <p className="floating-promo-expanded-desc">{promo.description}</p>
            )}
            <a href="tel:+15704217680" className="btn floating-promo-cta">
              Call Us Now
            </a>
          </div>
        </div>
      )}

      {/* Floating card */}
      {!expanded && (
        <div className="floating-promo">
          <button
            className="floating-promo-close"
            onClick={() => setDismissed(true)}
            aria-label="Dismiss promo"
          >
            &times;
          </button>
          <div className="floating-promo-content" onClick={() => setExpanded(true)}>
            {promo.imageUrl && (
              <img src={convertImageUrl(promo.imageUrl)} alt={promo.title} className="floating-promo-thumb" />
            )}
            <div className="floating-promo-text">
              <span className="floating-promo-badge">Special</span>
              <h4 className="floating-promo-title">{promo.title}</h4>
              <span className="floating-promo-tap">Tap for details</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FloatingPromo;
